import { render, staticRenderFns } from "./section_8.vue?vue&type=template&id=aca4c9d2&scoped=true&"
import script from "./section_8.vue?vue&type=script&lang=js&"
export * from "./section_8.vue?vue&type=script&lang=js&"
import style0 from "./section_8.vue?vue&type=style&index=0&id=aca4c9d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca4c9d2",
  null
  
)

component.options.__file = "section_8.vue"
export default component.exports